import { useMutation, useApolloClient } from '@apollo/client';
import { t } from '@lingui/macro';
import { useToast } from '@pocketlaw/tetris';
import { CREATE_API_KEY } from './mutation';
export function useCreateApiKey() {
    const { cache } = useApolloClient();
    const { addToast } = useToast();
    const [mutate, { data, loading, error, reset }] = useMutation(CREATE_API_KEY);
    const createApiKey = (input) => mutate({
        variables: {
            input,
        },
        onCompleted: () => {
            addToast({
                title: t({
                    message: 'Successfully created API key',
                    comment: 'Success message when creating API key succeeds',
                }),
                appearance: 'success',
            });
        },
        onError: () => {
            addToast({
                title: t({
                    message: 'Failed to create API key',
                    comment: 'Error message when creating API key fails',
                }),
                appearance: 'danger',
            });
        },
    });
    const handleReset = () => {
        if (data === null || data === void 0 ? void 0 : data.createWebApiClient) {
            cache.modify({
                fields: {
                    webApiClients(existing = [], { toReference, canRead }) {
                        const existingRefs = existing.filter(canRead);
                        const ref = toReference(data.createWebApiClient);
                        return [...existingRefs, ref];
                    },
                },
            });
            reset();
        }
    };
    const { user } = (data === null || data === void 0 ? void 0 : data.createWebApiClient.createdByCompanyUser) || {};
    const createWebApiClient = data
        ? Object.assign(Object.assign({}, data.createWebApiClient), { userName: user === null || user === void 0 ? void 0 : user.name }) : undefined;
    return {
        createApiKey,
        loading,
        error,
        data: createWebApiClient,
        reset: handleReset,
    };
}
